export default __webpack_public_path__ + "static/media/HEADERS-Exchange.ae548576.png";